'use strict';

var _ = require('lodash');
var CriteriaRuleController = function CriteriaRuleController($scope, criteriaRuleService, commonUiConstants, criteriaRuleDataService, $rootScope, currentStateCriteriaService, searchCriteriaValidationService) {
  $scope.selected = $scope.searchCriteria;
  var selectedLevel = $scope.selected.level || 'Default';
  var selectedCategory = $scope.selected.category;
  var selectedCriterion = $scope.selected.criterion;
  var selectedOperator = $scope.selected.operator;
  $scope.hasLevels = false;
  $scope.updateCategories = function () {
    var rules = currentStateCriteriaService.getSearchCriteria().rules;
    $scope.categories = criteriaRuleService.getCategories($scope.searchContext, $scope.selected.level, $scope.selected, rules);
  };
  $scope.updateLevels = function () {
    var rules = currentStateCriteriaService.getSearchCriteria().rules;
    var levels = criteriaRuleService.getLevels($scope.searchContext, $scope.selected, rules);
    if (!_.isEmpty(levels) && levels[0] !== 'Default') {
      $scope.levels = levels;
      $scope.hasLevels = true;
      $scope.selected.level = $scope.selected.level === 'Default' ? undefined : $scope.selected.level;
    }
    $scope.updateCategories();
  };
  $scope.updateLevels();
  $scope.criteria = criteriaRuleService.getCriteria($scope.searchContext, selectedLevel, selectedCategory);
  $scope.operators = criteriaRuleService.getOperators($scope.searchContext, selectedLevel, selectedCategory, selectedCriterion);
  $scope.valueType = criteriaRuleService.getValueType($scope.searchContext, selectedLevel, selectedCategory, selectedCriterion, selectedOperator);
  $scope.selectionLimit = criteriaRuleService.getSelectionLimit($scope.searchContext, selectedCategory, selectedCriterion);
  function fillOperandData() {
    var operandLimits = criteriaRuleService.getOperandLimits($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion);
    var criteriaNameForData = criteriaRuleService.getCriteriaNameForData($scope.searchContext, $scope.selected.category, $scope.selected.criterion);
    var criterion = criteriaNameForData || $scope.selected.criterion;
    $scope.selected.valueType = $scope.valueType;
    $scope.selected.setLimits(operandLimits);
    var leftOperandData = criteriaRuleDataService.getOperandData(criterion, $scope.selected.operator, $scope.valueType);
    if (criteriaRuleDataService.isEligibleCriterionFor2Multi(criterion)) {
      $scope.leftOperandData = leftOperandData[$scope.valueType];
      $scope.leftOperandData2 = leftOperandData['2multi'];
    } else {
      $scope.leftOperandData = leftOperandData;
      $scope.leftOperandData2 = [];
    }
    $rootScope.$broadcast('search-criteria:leftOperandChanged');
  }
  fillOperandData();
  $scope.POSITIVE_INT_PATTERN = commonUiConstants.POSITIVE_INT_PATTERN;
  function setInitValue() {
    $scope.selected.leftOperand = criteriaRuleService.getDefaultFieldValue($scope.valueType);
    $scope.selected.leftOperand2 = criteriaRuleService.getDefaultFieldValue($scope.valueType);
    if ($scope.isRightOperand()) {
      $scope.selected.rightOperand = criteriaRuleService.getDefaultFieldValue($scope.valueType);
    }
  }
  function clearModel(withOperator, withMetaCategory, withCriteria, withCategory) {
    $scope.selected.leftOperand = null;
    $scope.selected.leftOperand2 = null;
    $scope.selected.rightOperand = null;
    $scope.selected.field = null;
    if (withCategory) {
      $scope.selected.category = null;
    }
    if (withCriteria) {
      $scope.selected.criterion = null;
    }
    if (withOperator) {
      $scope.selected.operator = null;
    }
    if (withMetaCategory) {
      $scope.selected.metaCategory = null;
    }
  }
  $scope.onLevelChange = function () {
    $rootScope.$broadcast('search-criteria-level-changed');
    $scope.operators = null;
    clearModel(true, true, true, true);
  };
  $scope.onCategoryChange = function () {
    $rootScope.$broadcast('search-criteria-category-changed');
    $scope.criteria = criteriaRuleService.getCriteria($scope.searchContext, $scope.selected.level, $scope.selected.category);
    $scope.operators = null;
    clearModel(true, true, true);
  };
  $scope.areCategoriesVisible = function () {
    return !$scope.hasLevels || !!($scope.selected.level && $scope.selected.level !== 'Default');
  };
  $scope.onCriteriaChange = function () {
    $scope.operators = criteriaRuleService.getOperators($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion);
    $scope.field = criteriaRuleService.getField($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion);
    $scope.metaCategory = criteriaRuleService.getMetaCategory($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion);
    $scope.selectionLimit = criteriaRuleService.getSelectionLimit($scope.searchContext, $scope.selected.category, $scope.selected.criterion);
    clearModel(true, true);
    if ($scope.operators.length > 0) {
      $scope.selected.operator = $scope.operators[0];
      $scope.onOperatorChange();
    }
    if ($scope.field) {
      $scope.selected.field = $scope.field;
    }
    if ($scope.metaCategory) {
      $scope.selected.metaCategory = $scope.metaCategory;
    }
    $scope.selected.shortCriterionName = criteriaRuleService.getShortCriterionName($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion);
  };
  $scope.onOperatorChange = function () {
    $scope.valueType = criteriaRuleService.getValueType($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion, $scope.selected.operator);
    $scope.field = criteriaRuleService.getField($scope.searchContext, $scope.selected.level, $scope.selected.category, $scope.selected.criterion);
    clearModel();
    if ($scope.field) {
      $scope.selected.field = $scope.field;
    }
    fillOperandData();
    setInitValue();
  };
  $scope.isRightOperand = function () {
    var types = ['2int', '2percent', '2datetime', '2date', '2time', 'utc2date', '2combo'];
    return _.includes(types, $scope.valueType);
  };
  $scope.getIntMin = function () {
    return _.get($scope.selected, ['limits', 'min'], 0);
  };
  $scope.getIntMax = function () {
    return _.get($scope.selected, ['limits', 'max'], Number.MAX_VALUE);
  };
  $scope.$watch('selected', function (newObj, oldObj) {
    if (newObj !== oldObj) {
      $scope.criteriaUpdated();
      if ($scope.valueType === '2date' || $scope.valueType === 'utc2date') {
        searchCriteriaValidationService.update2datetimePickerValues(newObj, oldObj);
      }
    }
  }, true);
};
CriteriaRuleController.$inject = ['$scope', 'CriteriaRuleService', 'CommonUiConstants', 'CriteriaRuleDataService', '$rootScope', 'CurrentStateCriteriaService', 'SearchCriteriaValidationService'];
module.exports = CriteriaRuleController;